import InstallmentFormSection from "./InstallmentFormSection";
import InstallmentsListFormSection from "./InstallmentsListFormSection";
import ProductCustomerOrderFieldFormSection from "./ProductCustomerOrderFieldFormSection";
import ProductPricedOrderFieldFormSection from "./ProductPricedOrderFieldFormSection";

export {
  InstallmentFormSection as Installment,
  InstallmentsListFormSection as InstallmentsList,
  ProductCustomerOrderFieldFormSection as ProductCustomerOrderField,
  ProductPricedOrderFieldFormSection as ProductPricedOrderField,
};



// WEBPACK FOOTER //
// ./src/lib/components/FormSection/index.js